export default {
  priv: 'manage',
  overviewTitle: 'ErrorEvents',
  detailTitle: 'ErrorEvent',
  deleteTitle: 'dit event',
  url: '/manage/errorevents',
  apiUrl: '/errorevents/',
  sortBy: ['timestamp'],
  sortDesc: [true],
  deletable: false,
  editable: true,
  filterName: 'errorevents',
  quickFilter: {
    text: 'Zoek op timestamp',
    value: 'timestamp',
    type: 'text'
  },
  newRecord: {
    is_active: true
  },
  isReadOnlyOverview: true,
  customEditable(context, item) {
    return false;
  },
  customDeletable(context, item) {
    return true;
  },
  tableFields: [
    {text: 'TimeStamp', value: 'timestamp', link: '/manage/errorevents/{id}', width: '10%', filter: 'timestamp_sec'},
    {text: 'User', value: 'user_full_name', width: '5%'},
    {text: 'HTTP', value: 'http_code', width: '5%'},
    {text: 'ExceptionType', value: 'exception_type', width: '10%'},
    {text: 'Message', value: 'message', width: '10%'},
    {text: 'Method', value: 'method', width: '10%'},
    {text: 'URL', value: 'url', width: '10%'}
  ]
};
